import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import Welcome from './pages/Welcome/welcome';
import UsageItem from './pages/UsageItem/usage-item';
import 'bootstrap/dist/css/bootstrap.min.css';
import UsageExternal from './pages/UsageExternal/usage-external';


function App() {
  return (
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/usage/item/:id" element={<UsageItem />} />
            <Route path="/usage/form/:id" element={<UsageExternal />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
